import { MapPin, ArrowUpRight } from "lucide-react";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { ScoreGauge } from "./ScoreGauge";
import { eur } from "@/lib/format";

const FLOW_DATA = [
  { name: "Ingresos", v: 16200 },
  { name: "Gastos", v: -2280 },
  { name: "Hipoteca", v: -10440 },
  { name: "Cash flow", v: 4620 },
];
const FLOW_COLORS = ["#0F172A", "#F59E0B", "#6366F1", "#10B981"];

const Metric = ({ label, value, positive, testid }) => (
  <div className="rounded-2xl border border-slate-100 bg-slate-50/60 p-3.5" data-testid={testid}>
    <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</p>
    <p className={`mt-1 font-mono text-lg font-bold tabular-nums ${positive === true ? "text-emerald-600" : positive === false ? "text-red-500" : "text-slate-900"}`}>
      {value}
    </p>
  </div>
);

export const DashboardPreview = () => (
  <div
    data-testid="dashboard-preview-section"
    className="relative mx-auto w-full max-w-4xl rounded-[2rem] border border-slate-200 bg-white p-5 shadow-2xl shadow-slate-900/10 sm:p-7"
  >
    <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-2.5">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-50">
          <MapPin className="h-4.5 w-4.5 h-5 w-5 text-emerald-600" />
        </div>
        <div>
          <p className="font-display text-sm font-bold text-slate-900 sm:text-base">Calle Serrano 42, 3ºB · Madrid</p>
          <p className="text-xs text-slate-500">Análisis generado en 47 segundos</p>
        </div>
      </div>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-700">
        <span className="relative flex h-2 w-2">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />
          <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500" />
        </span>
        En directo
      </span>
    </div>

    <div className="grid gap-5 lg:grid-cols-[280px_1fr]">
      <div className="flex flex-col items-center justify-center rounded-3xl border border-slate-100 bg-gradient-to-b from-slate-50 to-white p-5">
        <ScoreGauge score={88} tone="emerald" testid="preview-pisoscore-gauge" />
        <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-emerald-500 px-3.5 py-1.5 text-xs font-bold text-white">
          <ArrowUpRight className="h-3.5 w-3.5" /> Inversión excelente
        </span>
      </div>

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          <Metric label="Precio compra" value={eur(240000)} testid="preview-precio-compra" />
          <Metric label="Alquiler" value={`${eur(1350)}/mes`} testid="preview-alquiler" />
          <Metric label="Rent. bruta" value="6,75 %" testid="preview-rentabilidad-bruta" />
          <Metric label="Rent. neta" value="5,12 %" positive testid="preview-rentabilidad-neta" />
          <Metric label="Cash flow" value="+385 €/mes" positive testid="preview-cash-flow" />
          <Metric label="ROI 10 años" value="142 %" positive testid="preview-roi" />
        </div>
        <div className="rounded-2xl border border-slate-100 p-3">
          <p className="mb-1 px-1 text-[11px] font-semibold uppercase tracking-wider text-slate-500">Balance anual</p>
          <div className="h-36">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={FLOW_DATA} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
                <XAxis dataKey="name" tickLine={false} axisLine={false} tick={{ fontSize: 11, fill: "#64748B" }} interval={0} />
                <Tooltip cursor={{ fill: "rgba(15,23,42,0.04)" }} formatter={(v) => eur(v)} />
                <Bar dataKey="v" radius={[6, 6, 6, 6]}>
                  {FLOW_DATA.map((d, i) => (
                    <Cell key={i} fill={FLOW_COLORS[i]} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  </div>
);
